
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 254 254","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"254","height":"254","rx":"127","fill":"#017737"}}),_c('path',{attrs:{"d":"M196.68 105.85c0 34.36-22.17 57.86-53.87 57.86-15.07 0-27.49-6.21-32.14-13.97l.22 7.98v49.21H78.53V79.69c0-1.77-.44-2.22-2.44-2.22H65V50.43h27.05c12.41 0 15.52 10.64 16.4 15.3 4.88-8.2 17.73-17.73 35.91-17.73 31.26-.01 52.32 23.26 52.32 57.85zm-33.03.22c0-18.4-11.97-31.03-27.05-31.03-12.41 0-26.38 8.2-26.38 31.26 0 15.07 8.42 30.81 25.94 30.81 12.86-.01 27.49-9.32 27.49-31.04z","fill":"#fff"}})])
          )
        }
      }
    